module.exports = __webpack_public_path__ + "static_pc/img/6.df3a4c7d.jpg";